import { type BusinessContactFormValuesType } from './BusinessContactFormSchema';

export const mapFormDataToMultipartFormat = (
    formData: BusinessContactFormValuesType,
): FormData => {
    const multipartFormData = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
        !!value && multipartFormData.append(key, value);
    });

    return multipartFormData;
};
